import React, { useEffect, useState } from 'react';
import Styles from './EventEvaluationType.module.css';

import { Dropdown, FormLabel, ProviderConsumer } from '@fluentui/react-northstar';
import { AUTOMATION_OPERATORS, CustomPropertiesAnswerJsonKey, ENTITY_TYPE } from '../../utils/constants';
import { useTranslation } from 'react-i18next';
import { appState } from '../../../AppState';
import { CustomPropertyDataType_LABELS } from '../../../custom-properties/utils/constants';

interface Props {
  evaluationType: string;
  updateEvaluationType: (property: string) => void;
  property: string
  entityName: string
}

export const EventEvaluationType = ({
  evaluationType,
  updateEvaluationType,
  property,
  entityName
}: Props) => {
  const {t} = useTranslation();
  const currentState = appState();

  const [evaluationTypeList, setEvaluationTypeList] = useState<
      DropdownDataModel[]
    >([]);

    

  useEffect(() => {
    let isMultiCustomProperty = false;
    if(property.startsWith(`${CustomPropertiesAnswerJsonKey}.`)){
      const propId = property.replace(`${CustomPropertiesAnswerJsonKey}.`, "");
      const propData = currentState?.customProperties.find(cp => cp.PropertyId == propId);
      if(propData && CustomPropertyDataType_LABELS.LIST == CustomPropertyDataType_LABELS[propData.DataType])
        isMultiCustomProperty = propData.CustomPropertyListConfiguration?.AllowMultiple ?? false;
    } 
    let actionsFilter = (entityName === ENTITY_TYPE.Approval && property === "title") ? "approvaltitle" : property.toLowerCase();
    let evaluationNone = ['tags', 'comments', 'servicelevelagreement', 'approvaltitle', 'relatedtickets',
                          "ticketlifecyclephase.name","approvers","phases.name","ticketcollaborators","affectedusers",
                          "affecteduserscount","collaboratorscount","agenttime"];
    if (evaluationNone.includes(actionsFilter) || isMultiCustomProperty) 
      setEvaluationTypeList(AUTOMATION_OPERATORS.noneEvaluationType);
    else if (property=="template")
      setEvaluationTypeList(AUTOMATION_OPERATORS.templateEvaluationType);
    else if (property=="activephase")
      setEvaluationTypeList(AUTOMATION_OPERATORS.activePhaseEvaluationType);
    else 
      setEvaluationTypeList(AUTOMATION_OPERATORS.evaluationType);
  }, [property, entityName]);

  const automationPropertyChange = (e, p) => {
    const data = p.value as DropdownDataModel;
    updateEvaluationType(data.value);
  };


  return (
    <ProviderConsumer render={globalTheme =>
      <div className={Styles.GroupInput}>
        <FormLabel content={t('automation.property-field.evaluation-type')} styles={{ fontSize: '12px' }} />
        <Dropdown
          inverted
          fluid
          items={evaluationTypeList}
          placeholder={t('automation.property-field.select-evaluation-type')}
          style={{ backgroundColor: globalTheme.siteVariables.colorScheme.default.background }}
          value={evaluationTypeList.filter(x => x.value == evaluationType)}
          onChange={automationPropertyChange}
        />
      </div>
    } />
  );
};
